import { Reveal } from "@/components/Motion";
import { PricingTeaser } from "@/components/pricing/PricingTeaser";

export default function Pricing() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14 lg:py-20" data-testid="pricing-page">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <span className="text-xs uppercase tracking-widest font-semibold text-teal">Pricing</span>
          <h1 className="font-heading font-extrabold text-navy tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-2">One flat fee.<br />No commission. Ever.</h1>
          <p className="text-slatev mt-5 text-base sm:text-lg max-w-md">Choose how you sell. Every pound of the sale stays with you.</p>
        </Reveal>
        <PricingTeaser />
      </div>
      <p className="text-center text-xs text-slatev mt-16">Test mode: use card 4242 4242 4242 4242, any future expiry and CVC.</p>
    </div>
  );
}
